import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Form, Row } from "react-bootstrap";
import { MetricsDateSelector } from '../../filters/MetricsDateSelector';
import { METRICS_PERIOD_OPTIONS } from '../../filters/metricsFilterOptions';
import { USER_EVENTS_EVENT_TYPE_OPTIONS } from './AdminUserEventsReport';


export const AdminUserEventsReportFilterBar = (props: {
    filterOptions: any,
    updateFilterOptions: any,
    filterDateOptions: any,
    setFilterDateOptions: any,
    refresh: any,
    isLoading: boolean,
    user: any,
}) => {

    return (
        <>
            <Row className="metrics-sidebar-update">
                <Col md={12} className="d-grid gap-2">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {props.refresh()}}
                        disabled={props.isLoading}
                    >
                        {props.isLoading ? <><FontAwesomeIcon icon={faSpinner} spin /> Loading...</> : "Update"}
                    </Button>
                </Col>
            </Row>
            <Row className="mb-4" style={{marginTop: '48px'}}>
                <Col md={12}>
                    <div className="metrics-control-title">Date Range</div>
                    <MetricsDateSelector
                        filterDateOptions={props.filterDateOptions}
                        setFilterDateOptions={props.setFilterDateOptions}
                    />
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="metrics-control-title">Period</div>

                    <Form.Select className="d-flex" onChange={(e) => props.updateFilterOptions("period", e.target.value)}>
                        {
                            METRICS_PERIOD_OPTIONS.map((selectOption: any, index: number) => {
                                return (
                                    <option key={selectOption.id} selected={props.filterOptions["period"] === index} value={index}>
                                        {selectOption.name}
                                    </option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="metrics-control-title">Event Type</div>

                    <Form.Select className="d-flex" onChange={(e) => props.updateFilterOptions("event_type", e.target.value)}>
                        {
                            USER_EVENTS_EVENT_TYPE_OPTIONS.map((selectOption: any, index: number) => {
                                return (
                                    <option key={selectOption.id} selected={props.filterOptions["event_type"] === index} value={index}>
                                        {selectOption.name}
                                    </option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
            </Row>
        </>
    );
};
